var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBmp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M21,4c1.1,0,2,0.9,2,2l0,0v12c0,1.1-0.9,2-2,2l0,0H3c-1.1,0-2-0.9-2-2l0,0L1,6c0-1.1,0.9-2,2-2l0,0H21z  M6.1,8.7H2.9V15h3.3c0.4,0,0.7-0.1,1-0.2c0.3-0.1,0.5-0.4,0.7-0.7c0.2-0.3,0.3-0.6,0.3-1c0-0.4-0.1-0.7-0.2-0.9 c-0.1-0.2-0.4-0.4-0.7-0.5c0.2-0.1,0.4-0.3,0.5-0.5C8,11,8.1,10.7,8.1,10.4c0-0.6-0.2-1-0.5-1.3C7.2,8.9,6.7,8.7,6.1,8.7z M10.5,8.7 H8.9V15h1.5v-3.2l1.5,3.2h0.7l1.5-3.2V15h1.5V8.7h-1.5l-1.8,3.9L10.5,8.7z M19.2,8.7h-2.8V15H18v-1.9h1.2c0.7,0,1.3-0.2,1.8-0.6 s0.7-0.9,0.7-1.6c0-0.7-0.2-1.2-0.7-1.6C20.5,8.9,19.9,8.7,19.2,8.7z M5.8,12.4c0.3,0,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.6 c0,0.3-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.6,0.2H4.5v-1.4H5.8z M18.9,10c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.3,0.3,0.7 s-0.1,0.6-0.3,0.7s-0.4,0.2-0.8,0.2H18V10H18.9z M5.8,9.9c0.2,0,0.4,0,0.5,0.1s0.2,0.3,0.2,0.5c0,0.4-0.2,0.7-0.7,0.7H4.5V9.9H5.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBmp);
export default __webpack_public_path__ + "static/media/ic_BMP.4706b973.svg";
export { ForwardRef as ReactComponent };